import { useFormik } from "formik";
import React, { useEffect } from "react";
import clsx from "clsx";
import { classeParaLabelsFormularioComFundoEscuro } from "../../../estilos/classeParaLabelsFormularioComFundoEscuro";
import { InputData } from "app/components/inputs/InputData";
import globalMU from "globalMU";

const estiloAbaEntrega = require("./aba-entrega.module.scss").default;
const estilosFormulario = require('../../../estilos/formulario.module.scss').default

export type Turno = {
  Description: string;
  Value: number;
};

export type Entrega = {
  CpfCnpjCliente: string;
  DataMarcadaEntrega: string;
  DataPrevisaoEntrega: string;
  EntregaPosterior: boolean;
  IdentificadorOrcamento: string;
  NomeCliente: string;
  TurnoEntrega: string;
  ExpedicaoExpressa: boolean;
  HabilitarExpedicaoExpressa: boolean;
  EntregaExpressa: boolean;
  ManterReserva: boolean;  // 455920/74856
  BloquearDesdobramento?: boolean; // 462218
  UserMessage?: string;
  Transforming: boolean
};

export type AbaEntregaProps = {
  todosTurnos: Turno[];
  entrega: Entrega;
  onAplicar: (entrega: Entrega) => void;
  dataMaximaParaPrevisaoEntrega?: { year: number, month: number, day: number }
  definirPrevisaoEntregaPorItem: boolean;
  vendaComEntregaPosterior: boolean;
  habilitarInputs: boolean;
  habilitarExpedicaoExpressa: boolean;
  usarSeparacaoExpedicaoExpressa: boolean;
  usarDefinirPrevisaoEntregaPorItem: boolean;
  replicarData: (entrega: Entrega, alterarDataPrevista: boolean) => void;
  incluir: boolean;
  alterar: boolean;
  onAlterarValor: (dados: Entrega) => void;
  permitidoAlterar: boolean;
  vendaComEntregaExpressa: boolean;
  somenteLeitura: boolean;
};

export const AbaEntrega = (props: AbaEntregaProps) => {
  const formik = useFormik({
    initialValues: { ...props.entrega },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const inputNomeCliente = <>
    <label>Nome do Cliente</label>
    <div style={{ background: "var(--mu-superficie, #FFF)", fontWeight: "600", paddingTop: "3px", paddingBottom: "3px" }}>
      {formik.values.NomeCliente}
    </div>
  </>

  const campoCNPJCPF = <>
    <label>CNPJ / CPF</label>
    <div>{formik.values.CpfCnpjCliente}</div>
  </>

  const campoDataPrevista = <>
    <label
      title="Veja parâmetros: &#0013;-Número máximo de dias para a previsão de entrega&#0013;-Número máximo de dias para a previsão de entrega de encomenda"
    >Data Prevista</label>
    <div className={estiloAbaEntrega.bordaEscura}>
       <InputData
        disabled={!props.permitidoAlterar || props.somenteLeitura}
        id="AbaEntrega_DataPrevisaoEntrega"
        key="AbaEntrega_DataPrevisaoEntrega"
        bloquearDataMenorQueHoje={true}
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataPrevisaoEntrega)}
        dataMaxima={props.dataMaximaParaPrevisaoEntrega}
        onChange={(e) => {
          formik.setFieldValue("DataPrevisaoEntrega", e)
          props.onAlterarValor({
            ...formik.values,
            DataPrevisaoEntrega: e
          })
        }}
        selecionaValorOnFocus
      />
      {props.usarDefinirPrevisaoEntregaPorItem && !formik.values.BloquearDesdobramento && formik.values.DataPrevisaoEntrega?.length > 0 && props.permitidoAlterar && !props.somenteLeitura &&
        (
          <button
            title="Replica a data prevista de entrega para todos os itens do orçamento"
            className={estiloAbaEntrega.botaoReplicarData}
            onClick={() => props.replicarData(formik.values, true)}
            key="AbaEntrega_BotaoReplicarDataPrevista"
            id="AbaEntrega_BotaoReplicarDataPrevista"
          >
            Replicar para Todos os Itens
          </button>
        )}
    </div>
  </>

  const campoDataMarcada = <>
    <label>Data Marcada</label>
    <div className={estiloAbaEntrega.bordaEscura}>
      <InputData
        disabled={!props.permitidoAlterar || props.somenteLeitura}
        id="AbaEntrega_DataMarcadaEntrega"
        key="AbaEntrega_DataMarcadaEntrega"
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataMarcadaEntrega)}
        bloquearDataMenorQueHoje={true}
        onChange={(e) => {
          formik.setFieldValue("DataMarcadaEntrega", e)
          props.onAlterarValor({
            ...formik.values,
            DataMarcadaEntrega: e
          })
        }}
        selecionaValorOnFocus
      />

      {props.usarDefinirPrevisaoEntregaPorItem && formik.values.DataMarcadaEntrega?.length > 0 && props.permitidoAlterar && !props.somenteLeitura &&
        (
          <button
            title="Replica a data marcada de entrega para todos os itens do orçamento"
            className={estiloAbaEntrega.botaoReplicarData}
            onClick={() => props.replicarData(formik.values, false)}
            key="AbaEntrega_BotaoReplicarDataMarcada"
            id="AbaEntrega_BotaoReplicarDataMarcada"
          >
            Replicar para Todos os Itens
          </button>
        )}
    </div>

    <label>Turno</label>
    <div className={estiloAbaEntrega.bordaEscura}>
      <select
        className={estiloAbaEntrega.select}
        name="TurnoEntrega"
        id="AbaEntrega_TurnoEntrega"
        key="AbaEntrega_TurnoEntrega"
        value={formik.values.TurnoEntrega ?? ""}
        disabled={!props.permitidoAlterar || props.somenteLeitura}
        onChange={(e) => {
          
          formik.setFieldValue("TurnoEntrega", e.target.value)
          props.onAlterarValor({
            ...formik.values,
            TurnoEntrega: e.target.value
          })
        }}
      >
        <option value=""></option>
        {props.todosTurnos?.map((f) => (
          <option key={f.Value} value={f.Value}>
            {f.Description}
          </option>
        ))}
      </select>
    </div>
  </>

  const campoEntregaPosterior = <>
    <label htmlFor="AbaEntrega_EntregaPosterior" className="_cursor-pointer" >Entrega Posterior </label>
    <div className={estiloAbaEntrega.Checkbox}>
      <input
        type="checkbox"
        name="EntregaPosterior"
        id="AbaEntrega_EntregaPosterior"
        key="AbaEntrega_EntregaPosterior"
        className={estiloAbaEntrega.selection}
        checked={formik.values.EntregaPosterior ?? false}
        onChange={(e) => {
          formik.setFieldValue("EntregaPosterior", e.target.checked)
          props.onAlterarValor({
            ...formik.values,
            EntregaPosterior: e.target.checked
          })
        }}
        disabled={!props.vendaComEntregaPosterior || !props.permitidoAlterar || props.somenteLeitura}
      />
    </div>
  </>

  const campoSeparacaoExpressa = <>
    <label htmlFor="AbaEntrega_SeparacaoExpedicaoExpressa" className="_cursor-pointer" >Separação Expressa na Expedição </label>
    <div className={estiloAbaEntrega.Checkbox}>
      <input
        style={
          !props.habilitarExpedicaoExpressa
            ? { cursor: "not-allowed" }
            : {}
        }
        type="checkbox"
        name="ExpedicaoExpressa"
        id="AbaEntrega_SeparacaoExpedicaoExpressa"
        key="AbaEntrega_SeparacaoExpedicaoExpressa"
        className={estiloAbaEntrega.selection}
        checked={formik.values.ExpedicaoExpressa ?? false}
        onChange={(e) => {
          formik.setFieldValue("ExpedicaoExpressa", e.target.checked)
          props.onAlterarValor({
            ...formik.values,
            ExpedicaoExpressa: e.target.checked
          })
        }}
        disabled={!props.habilitarExpedicaoExpressa || !props.permitidoAlterar || props.somenteLeitura}
      />
    </div>
  </>

const campoManterReserva = <>
<label 
  htmlFor="AbaEntrega_CampoManterReserva" 
  className="_cursor-pointer" 
  title="Quando marcado, será solicitado senha liberação [Libera solicitação para manutenção de reserva] ao finalizar o orçamento"
  >Manter Reserva</label>
<div className={estiloAbaEntrega.Checkbox}>
  <input
    type="checkbox"
    id="AbaEntrega_CampoManterReserva"
    key="AbaEntrega_CampoManterReserva"
    className={estiloAbaEntrega.selection}
    checked={formik.values.ManterReserva ?? false}
    onChange={(e) => {
      formik.setFieldValue("ManterReserva", e.target.checked)
      props.onAlterarValor({
        ...formik.values,
        ManterReserva: e.target.checked
      })
    }}
    disabled={!props.permitidoAlterar || props.somenteLeitura}
  />
</div>
</>

 
  const campoEntregaExpressa = <>
    <label htmlFor="AbaEntrega_CampoEntregaExpressa" className="_cursor-pointer" >Entrega Expressa </label>
    <div className={estiloAbaEntrega.Checkbox}>
      <input
        type="checkbox"
        name="EntregaExpressa"
        id="AbaEntrega_CampoEntregaExpressa"
        key="AbaEntrega_CampoEntregaExpressa"
        className={estiloAbaEntrega.selection}
        checked={formik.values.EntregaExpressa ?? false}
        //d={formik.values.EntregaExpressa}
        onChange={(e) => {
          formik.setFieldValue("EntregaExpressa", e.target.checked)
          props.onAlterarValor({
            ...formik.values,
            EntregaExpressa: e.target.checked
          })
        }}
        disabled={!props.permitidoAlterar || props.somenteLeitura}
      />
    </div>
  </>

const campoBloquearDesdobramento = <> 
<label 
  htmlFor="AbaEntrega_CampoBloquearDesdobramento" 
  className="_cursor-pointer" 
  >Bloquear Desdobramento</label>
<div className={estiloAbaEntrega.Checkbox}>
  <input
    type="checkbox"
    id="AbaEntrega_CampoBloquearDesdobramento"
    key='AbaEntrega_CampoBloquearDesdobramento'
    className={estiloAbaEntrega.selection}
    checked={formik.values.BloquearDesdobramento ?? false} // 462218
    onChange={(e) => {
      formik.setFieldValue("BloquearDesdobramento", e.target.checked)
      props.onAlterarValor({
        ...formik.values,
        BloquearDesdobramento: e.target.checked
      })
    }}
    disabled={props.somenteLeitura}
  />
</div>
</>


  return (
    <>
      <div className={clsx(estilosFormulario.formulario, classeParaLabelsFormularioComFundoEscuro)}>
        {inputNomeCliente}

        {campoCNPJCPF}

        {campoDataPrevista}

        {props.definirPrevisaoEntregaPorItem && campoDataMarcada}

        {props.vendaComEntregaPosterior && campoEntregaPosterior}

        {props.usarSeparacaoExpedicaoExpressa && campoSeparacaoExpressa}

        {props.vendaComEntregaExpressa && campoEntregaExpressa}

        {campoManterReserva}

        {campoBloquearDesdobramento}
      </div>
      <br />
      {((props.incluir || props.alterar) && !props.somenteLeitura) && (
        <div className={estiloAbaEntrega.buttonAbaEntrega}>
          <button onClick={() => props.onAplicar(formik.values)}
            id="AbaEntrega_BotaoAplicar"
          >
            Aplicar
          </button>
        </div>
      )}
    </>
  );
};
